function Loading() {
  return (
    <div className="loading">
      <div className="loading__spinner"></div>
      <p>Loading Pokémon...</p>
    </div>
  );
}

export default Loading;
